import { getLmsWebLoggedin } from 'src/models/lmsConfig/queries';
import { getNavigationItems, isLmsWeb, isSelfServe } from 'src/workspace/utils';

export const showLmsWebHeader = () =>
  Boolean(isLmsWeb() && getLmsWebLoggedin());

export const showSelfServeHeader = () =>
  Boolean(isSelfServe() && getNavigationItems().length);
